import React, {useState} from 'react';
import Popup from '../common/components/Popup';
import PopupWarningContent from '../manage-users/PopupWarningContent';
import Select from 'react-select';
import {SELECT_PLACEHOLDER} from '../../constants/permission';
import CustomDropdownIndicator from '../common/components/CustomDropdownIndicator';


interface deleteRolePopupProps {
    showPopup: boolean,
    noOfuser: number,
    roleId: string,
    roleName: string,
    roleList?: {value: string, label: string}[],
    onClose: (show: boolean) => void,
    onDelete: (move?: {oldId: string, newId: string}) => void,
}

function DeleteRolePopup(props: deleteRolePopupProps) {
    const {showPopup, noOfuser, roleName, roleList, roleId,
        onClose, onDelete} = props;

    const [
        roleToChange,
        setRoleToChange,
    ] = useState<{value: string, label: string}>({
            value: SELECT_PLACEHOLDER, label: SELECT_PLACEHOLDER});

    const headerText = 'Are you sure you want to delete role';

    const handleRoleChange = (newValue: any) => {
        setRoleToChange(newValue);
    };

    return (
        <Popup
            show={showPopup}
            onClose={() => onClose(false)}
            title={!noOfuser ? `${headerText} "${roleName}"` : `${headerText}?`}
            size='lg'
            primaryCtaText={!noOfuser ? 'Delete Role': 'Move users & Delete'}
            disablePrimaryCta={
                !noOfuser ? false :
                roleToChange.value !== SELECT_PLACEHOLDER ? false : true}
            primaryCtaOnClick={() =>
                onDelete(noOfuser ?
                    {oldId: roleId, newId: roleToChange.value} : undefined)}
            secondaryCtaText='Cancel'
            secondaryCtaOnClick={() => onClose(false)}
            customClassName='manage-user-menu-popup'
        >
            {noOfuser && (
                <>
                    <PopupWarningContent mainContent={`There are ${noOfuser} users currently assigned to this role. Please change them to a different role before deleting.`}/>
                    <div className='manage-user-detail-page'>
                        <label className='form-label mt-2'>Change Role To</label>
                        <Select
                            options={roleList ?
                                roleList.filter((role) =>
                                    role.value !== roleId) : []}
                            defaultValue={roleToChange}
                            value={roleToChange}
                            placeholder={'Select Role'}
                            isSearchable
                            onChange={handleRoleChange}
                            className='input-select'
                            components={{
                                DropdownIndicator: CustomDropdownIndicator}}
                            styles={{
                                indicatorSeparator: (base) => ({
                                    ...base,
                                    display: 'none',
                                }),
                            }}
                        ></Select>
                    </div>
                </>
            )}
        </Popup>
    );
}

export default DeleteRolePopup;
